{
  "Clear search": "נקה חיפוש"
}